import { useEffect, useState } from "react";
import "./styles/AttendanceReport.css";
import { getSchoolId } from "../../Utility/commonFunctions";
import { baseUrl } from "../../Utility/constants";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

// Safe value helper
const v = (x) => (x === 0 ? 0 : x || "");

// Loader component
const Loader = () => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,0.8)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  }}>
    <Spinner animation="border" role="status" variant="primary" style={{ width: '4rem', height: '4rem' }} />
    <p style={{ marginTop: '15px', fontSize: '16px', color: '#333' }}>Loading attendance data...</p>
  </div>
);

// Minorities table
const MinorityTable = ({ data }) => (
  <table className="minority-table">
    <thead>
      <tr>
        <th>Religion</th><th>Boys</th><th>Girls</th><th>Total</th>
      </tr>
    </thead>
    <tbody>
      {data.length ? data.map((r, idx) => (
        <tr key={idx}>
          <td>{r.religionName}</td>
          <td>{r.boys}</td>
          <td>{r.girls}</td>
          <td>{r.total}</td>
        </tr>
      )) : (
        <tr><td colSpan={4} style={{ textAlign: 'center' }}>No data</td></tr>
      )}
    </tbody>
  </table>
);

// Caste table
const CasteTable = ({ dayData }) => {
  if (!dayData?.length) return null;
  const headers = Object.keys(dayData[0]?.counts || {});
  return (
    <table className="full-table first-last-table">
      <thead>
        <tr>
          <th>Category</th>
          {headers.map((h, i) => <th key={i}>{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {dayData.map((row) => (
          <tr key={row.type}>
            <td><strong>{row.type}</strong></td>
            {headers.map((h, i) => <td key={i}>{row.counts[h]}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

// Student details table
const StudentTable = ({ students, totalP, totalA }) => (
  <table className="full-table student-table">
    <thead>
      <tr>
        <th style={{ width: "125px" }}>GR No.</th>
        <th style={{ width: "125px" }}>Date of birth</th>
        <th style={{ width: "125px" }}>Caste</th>
        <th style={{ width: "125px" }}>Category</th>
        {/* <th>Fee details</th> */}
        <th style={{ width: "125px" }}>Mother's Name</th>
        <th style={{ width: "125px" }}>RollNo</th>
        <th>Name of student</th>
      </tr>
    </thead>
    <tbody>
      {students.length ? students.map((s, idx) => (
        <tr key={idx}>
          <td>{s.generalRegisterNo}</td>
          <td> {new Date(s.dateOfBirth).toLocaleDateString('en-GB').replace(/\//g, '-')}</td>
          <td>{s.casteName?.trim()?.toUpperCase() || ""}</td>
          <td>{s.categoryName?.trim()?.toUpperCase() || ""}</td>
          {/* <td></td> */}
          <td>{s.motherName?.trim()?.split(' ')?.[0]?.toUpperCase() || ""}</td>
          <td>{s.rollNo !== 0 ? s.rollNo : ''}</td>
          <td style={{ textAlign: "left" }}>{[s.firstName, s.middleName, s.lastName].filter(Boolean)?.join(" ")?.toUpperCase() || ""}</td>
        </tr>
      )) : (
        <tr><td colSpan={7} style={{ textAlign: 'center' }}>No students</td></tr>
      )}
      <tr><td></td><td></td><td></td>
        <td></td><td></td><td style={{ textAlign: 'left' }} colSpan={2}>Total Present students : {totalP} </td></tr>
      <tr><td></td><td></td><td></td>
        <td></td><td></td><td style={{ textAlign: 'left' }} colSpan={2}>Total absent students : {totalA} </td></tr>
      <tr>
        <td></td><td></td><td></td>
        <td></td><td></td>
        <td style={{ textAlign: 'left' }} colSpan={2}>
          Total students : {students.length}</td>
      </tr>
      <tr><td></td><td></td><td></td>
        <td></td><td></td><td style={{ textAlign: 'left' }} colSpan={2}>Class teachers signature</td></tr>

    </tbody>
  </table>
);

// Attendance table
const AttendanceTable = ({ students, monthDays, getDayName }) => (
  <div className="attendance-wrapper">
    <table className="attendance-table full-table">
      <thead>
        <tr>
          {/* <th>#</th> */}
          {/* <th rowSpan={2}>GR No</th> */}
          {/* {Array.from({ length: monthDays }, (_, i) => <th key={i}>{i + 1}</th>)} */}
          {Array.from({ length: monthDays }, (_, i) => (
            <th key={i}>
              <div style={{ fontSize: "10px" }}>
                {getDayName(i + 1)}
              </div>
              <div>{i + 1}</div>
            </th>
          ))}

          <th style={{ minWidth: "120px" }}>
            TDM
          </th>
          <th style={{ minWidth: "120px" }}>
            TPY
          </th>
          <th style={{ minWidth: "100px" }}>
            TPD
          </th>
          <th style={{ minWidth: "100px" }}>
            R
          </th>
        </tr>
      </thead>
      <tbody>
        {students.length ? students.map((s, idx) => {
          const monthPresent = s.totals?.month ?? 0;
          const yearPresent = s.totals?.year ?? 0;
          const totalPresent = s.totals?.total ?? yearPresent;
          const remark = s.totals?.remark ?? "";
          return (
            <tr key={idx}>
              {/* <td>{idx + 1}</td> */}
              {/* <td className="left small">{s.grNo ?? "-"}</td> */}
              {/* {Array.from({ length: monthDays }, (_, i) => <td key={i}>{s.attendance?.[i + 1] ?? ""}</td>)} */}
              {Array.from({ length: monthDays }, (_, i) => {
                const day = i + 1;
                const attendance = s.attendance?.[day];
                return (
                  // <td key={i}>
                  //   {getDayName(day) === "Sun"
                  //     ? <span style={{ color: "Red" }}> S</span>
                  //     : (s.attendance?.[day] ?? "")}
                  // </td>
                  <td key={i}>
                    {s.attendance?.[day] === "H" ? (
                      <span style={{ color: "Orange", fontWeight: "bold" }}>H</span>
                    ) : getDayName(day) === "Sun" ? (
                      <span style={{ color: "red" }}>S</span>
                    ) : (
                      s.attendance?.[day] ?? ""
                    )}
                  </td>
                );
              })}
              <td>{monthPresent}</td>
              <td>{yearPresent}</td>
              <td>{totalPresent}</td>
              <td>{remark}</td>
            </tr>
          );
        }) : (
          <tr><td colSpan={monthDays + 5} style={{ textAlign: 'center' }}>No attendance data</td></tr>
        )}
      </tbody>
    </table>
  </div>
);

// Fee table
const FeeTable = ({ feeDetails }) => (
  <table className="full-table fee-table">
    <thead>
      <tr>
        <th>Week and date</th>
        <th>Semester fee</th>
        <th>Admission fee</th>
        <th>Tution fee</th>
        <th>Pending fee</th>
        <th>Laboratory fee</th>
        <th>Fine and other</th>
        <th>Total</th>
        <th>Clerks signature</th>
      </tr>
    </thead>
    <tbody>
      {Array.from({ length: 5 }, (_, i) => {
        const r = feeDetails[i] || {};
        return (
          <tr key={i}>
            <td>{r.weekDate || (i < 4 ? `${i + 1})` : "Total")}</td>
            <td>{v(r.semesterFee)}</td>
            <td>{v(r.admissionFee)}</td>
            <td>{v(r.tutionFee)}</td>
            <td>{v(r.pendingFee)}</td>
            <td>{v(r.labFee)}</td>
            <td>{v(r.fineOther)}</td>
            <td>{v(r.total)}</td>
            <td>{v(r.clerkSignature)}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

// Classification table
const ClassificationTable = () => {
  const labels = [
    "1] Paying complete fee",
    "2] E.B.C.",
    "3] Free education for girls",
    "4] B.C/B.C. once failed",
    "5] Seconday teachers child",
    "6] Primary teachers child",
    "7] Freedom fighters child",
    "8] Ex. Army person",
    "9] Other concessions",
  ];
  return (
    <table className="full-table classification-table">
      <thead>
        <tr>
          <th rowSpan="2" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>Classification of student</th>
          <th rowSpan="2" style={{ width: "70px" }}>Fee Rate</th>
          <th rowSpan="2" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>Number of students on start of month</th>
          <th colSpan="3" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>Student admitted in class</th>
          <th colSpan="3" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>Student left from class</th>
          <th rowSpan="2" style={{ whiteSpace: "normal", wordWrap: "break-word" }}>Number of students on end of month</th>
        </tr>
        <tr>
          <th>New Admission</th>
          <th style={{ width: "200px", whiteSpace: "normal", wordWrap: "break-word" }}>Pass and Admitted</th>
          <th>Division change</th>
          <th>Removed Name</th>
          <th style={{ whiteSpace: "normal", wordWrap: "break-word" }}>Passed and Left</th>
          <th>Division change</th>
        </tr>
      </thead>
      <tbody>
        {labels.map((label, idx) => (
          <tr key={idx}>
            <td className="left">{label}</td>
            <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
          </tr>
        ))}
        <tr className="total-row">
          <td className="left"><strong>Total</strong></td>
          <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
        </tr>
      </tbody>
    </table>
  );
};

// Left students table
const LeftStudentsTable = ({ leftStudents }) => {
  const rows = leftStudents.length ? leftStudents : Array(10).fill({});
  return (
    <table className="full-table left-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Gen. Register</th>
          <th>Name of student</th>
          <th>Date of leaving</th>
          <th>Pending fee</th>
          <th style={{ whiteSpace: "normal", wordWrap: "break-word", minWidth: "120px" }}>
            Reason of leaving school/Reason for division</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((_, i) => (
          <tr key={i}>
            <td>{i + 1}</td>
            <td></td><td></td><td></td><td></td><td></td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

// Syllabus table
// Syllabus table
const SyllabusTable = ({ syllabus }) => {
  const rows = syllabus.length ? syllabus : Array(9).fill({});
  return (
    <table className="full-table syllabus-table">
      <thead>
        <tr>
          <th>Subject</th>
          <th>Teacher Name</th>
          <th>Syllabus which is completed in month</th>
          <th>Signature</th>
        </tr>
      </thead>
      <tbody>
        {rows
          .sort((a, b) => {
            const codeA = Number(a.subjectCode) || 0;
            const codeB = Number(b.subjectCode) || 0;
            return codeA - codeB;
          })
          .map((r, i) => (
            <tr key={i}>
              <td>{v(r.subjectCode)}-{v(r.subjectName)}</td>
              <td>{v(r.completed)}</td>
              <td>{v(r.signature)}</td>
              <td></td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default function AttendanceReport() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const std = queryParams.get("std");
  const div = queryParams.get("div");
  const paramDate = queryParams.get("date");
  const date = paramDate ? new Date(paramDate) : new Date();
  const monthName = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();
  const teacherId = localStorage.getItem("userID");

  const [loading, setLoading] = useState(true);
  const [schoolData, setSchoolData] = useState({});
  const [teacherData, setTeacherData] = useState({});
  const [genderWiseData, setGenderWiseData] = useState({});
  const [minorityData, setMinorityData] = useState([]);
  const [casteData, setCasteData] = useState({ firstDay: [], lastDay: [] });
  const [studentsData, setStudentsData] = useState([]);
  const [studentsAttendanceData, setStudentsAttendanceData] = useState([]);
  const [feeDetails, setFeeDetails] = useState([]);
  const [classification, setClassification] = useState([]);
  const [leftStudents, setLeftStudents] = useState([]);
  const [syllabus, setSyllabus] = useState([]);
  const [totalP, setTotalP] = useState(0);
  const [totalA, setTotalA] = useState(0);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const schoolId = await getSchoolId();
        const teacherApiUrl = `${baseUrl}/api/Teachers/GetTeacherProfile?id=${teacherId}`;

        const requests = [
          axios.get(`${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`),
          axios.get(teacherApiUrl),
          axios.get(`${baseUrl}/api/Attendance/GetAttendanceSummary?TeacherId=${teacherId}${paramDate ? `&attendanceDate=${paramDate}` : ''}`),
          axios.get(`${baseUrl}/api/Attendance/GetAttendanceReligionSummary?TeacherId=${teacherId}${paramDate ? `&attendanceDate=${paramDate}` : ''}`),
          axios.get(`${baseUrl}/api/Attendance/GetAttendanceCasteSummary?TeacherId=${teacherId}${paramDate ? `&attendanceDate=${paramDate}` : ''}`),
          axios.get(`${baseUrl}/api/Attendance/GetStudentsDetailsFromAttendance?TeacherId=${teacherId}${paramDate ? `&attendanceDate=${paramDate}` : ''}`),
          axios.get(`${baseUrl}/api/Attendance/GetMonthlyAttendanceDetails?TeacherId=${teacherId}${paramDate ? `&attendanceDate=${paramDate}` : ''}`),
          axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectMasterForGraceMarksByTeacherId`, {
            params: {
              teacherId: teacherId
            },
          })
        ];

        const [
          schoolRes, teacherRes, genderRes,
          religionRes, casteRes, studentRes,
          attendanceRes, subjectRes
        ] = await Promise.allSettled(requests);

        if (schoolRes.status === "fulfilled") setSchoolData(schoolRes.value.data);
        if (teacherRes.status === "fulfilled") setTeacherData(teacherRes.value.data);
        if (genderRes.status === "fulfilled") setGenderWiseData(genderRes.value.data);
        if (religionRes.status === "fulfilled") setMinorityData(religionRes.value.data);
        if (casteRes.status === "fulfilled") setCasteData(casteRes.value.data || { firstDay: [], lastDay: [] });
        if (studentRes.status === "fulfilled") setStudentsData(studentRes.value.data);
        if (attendanceRes.status === "fulfilled") {
          const attData = attendanceRes.value.data;
          let p = 0;
          let a = 0;

          if (attData.students) {
            attData.students.forEach(student => {
              for (const key in student.attendance) {
                const value = student.attendance[key];

                if (value === "P") p++;
                else if (value === "A") a++;
              }
            });
          }
          setTotalP(p);
          setTotalA(a);

          setStudentsAttendanceData(attData.students || []);
          setFeeDetails(attData.feeDetails || []);
          setClassification(attData.classification || []);
          setLeftStudents(attData.leftStudents || []);
          //setSyllabus(attData.syllabus || []);
        }
        if (subjectRes.status === "fulfilled") setSyllabus(subjectRes.value.data);

      } catch (err) {
        console.error("Error loading attendance report:", err);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [paramDate]);

  // Determine number of days in month
  const monthDays = paramDate ? new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate() : 31;

  const getDayName = (day) => {
    const d = new Date(date.getFullYear(), date.getMonth(), day);
    return d.toLocaleDateString("en-US", { weekday: "short" });
  };

  if (loading) return <Loader />;

  return (
    <div className="attendance-report">
      <div className="report-controls">
        <button className="print-btn" onClick={() => window.print()}>Print Report</button>
      </div>

      {/* Header */}
      <header className="report-header">
        <div className="header-left">
          <div className="school-name">{schoolData.schoolOrCollegeName}</div>
          <div className="school-address">{schoolData.address}, {schoolData.pincode}</div>
          <div className="sheet-title">ATTENDANCE SHEET</div>
          <div className="meta">
            Standard: <strong>{v(std)}</strong> &nbsp; Division: <strong>{v(div)}</strong> &nbsp; Month:<strong>{monthName}-{year}</strong>
          </div>
          <section className="teacher-info">
            <div><strong>Name of class teacher:</strong> {teacherData?.fullName?.trim()?.toUpperCase() || ""}</div>
            <div className="totals-line">
              <strong>Total students: </strong>
              {genderWiseData?.boys} Boys + {genderWiseData?.girls} Girls = {genderWiseData?.total} &nbsp;&nbsp;
              <strong>Working Days:</strong> {genderWiseData?.workingDays}
            </div>
          </section>
        </div>
        <div className="header-right">
          <div className="minority-title">Minority students information</div>
          <MinorityTable data={minorityData} />
        </div>
      </header>

      <ClassificationTable classification={classification} />

      <section className="info-day-section">
        <h4>Information on first day of month</h4>
        <CasteTable dayData={casteData.firstDay} />
      </section>

      <section className="info-day-section">
        <h4>Information on last day of month</h4>
        <CasteTable dayData={casteData.lastDay} />
      </section>

      <section className="fee-section">
        <h4>Details of fee submitted by class teacher</h4>
        <FeeTable feeDetails={feeDetails} />
      </section>

      <section className="student-section print-page-break">
        {/* <h4>Student Details</h4> */}
        <StudentTable students={studentsData} totalA={totalA} totalP={totalP} />
      </section>

      <section className="attendance-section print-page-break">
        <h4>Attendance for the Month of {monthName} {year}</h4>
        <table className="attendance-table full-table">
          <tr>
            <th style={{ whiteSpace: "normal", minWidth: "120px" }}>
              TDM - Total days present in current month
            </th>
            <th style={{ whiteSpace: "normal", wordWrap: "break-word", minWidth: "120px" }}>
              TDY Total days present in current year
            </th>
            <th style={{ whiteSpace: "normal", wordWrap: "break-word", minWidth: "100px" }}>
              TPD - Total present days
            </th>
            <th style={{ whiteSpace: "normal", wordWrap: "break-word", minWidth: "100px" }}>
              R - Remark
            </th>
          </tr>
        </table>

        <AttendanceTable students={studentsAttendanceData} monthDays={monthDays} getDayName={getDayName} />
      </section>
      <div className="print-page-break">
        <section className="left-section">
          <h4>Students who have left the school or changed division</h4>
          <LeftStudentsTable leftStudents={leftStudents} />
        </section>

        <section className="syllabus-section">
          <h4>Information of syllabus and special activities</h4>
          <SyllabusTable syllabus={syllabus} />
        </section>
        <br></br><br></br><br></br><br></br>
        <footer className="final-signs">
          <div className="sign-row">
            <div><strong>Date:</strong> _________</div>
            <div><strong>Class teacher:</strong> _________</div>
            <div><strong>Clerk:</strong> _________</div>
            <div><strong>Vice-Principal:</strong> _________</div>
            <div><strong>Principal:</strong> _________</div>
          </div>
        </footer>
      </div>
    </div>
  );
}

